export default __webpack_public_path__ + "static/project-slide-8-1640-765-2b3869fe2ddc880cac708fea9d01e8ca.webp";